import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { Play, Pause, X, Clock } from 'lucide-react';
export const TimeTrackerCell = ({ value = {
    totalSeconds: 0,
    isRunning: false,
    sessions: [],
}, onChange, readonly = false, }) => {
    const [displaySeconds, setDisplaySeconds] = useState(value.totalSeconds);
    const [isRunning, setIsRunning] = useState(value.isRunning);
    const timerRef = useRef(null);
    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        if (hours > 0) {
            return `${hours}h ${minutes}m ${secs}s`;
        }
        if (minutes > 0) {
            return `${minutes}m ${secs}s`;
        }
        return `${secs}s`;
    };
    // Timer effect
    useEffect(() => {
        if (isRunning && !readonly) {
            timerRef.current = setInterval(() => {
                setDisplaySeconds((prev) => {
                    const newSeconds = prev + 1;
                    // Update the parent with the new time
                    onChange({
                        totalSeconds: newSeconds,
                        isRunning: true,
                        sessions: value.sessions,
                    });
                    return newSeconds;
                });
            }, 1000);
            return () => {
                if (timerRef.current) {
                    clearInterval(timerRef.current);
                }
            };
        }
    }, [isRunning, readonly, value.sessions, onChange]);
    const handlePlayPause = () => {
        if (readonly)
            return;
        const newIsRunning = !isRunning;
        setIsRunning(newIsRunning);
        if (newIsRunning) {
            // Start new session
            const newSession = {
                id: `session-${Date.now()}`,
                startTime: Date.now(),
            };
            onChange({
                totalSeconds: displaySeconds,
                isRunning: true,
                sessions: [...value.sessions, newSession],
            });
            console.log('[Time Tracking Started]', { sessionId: newSession.id });
        }
        else {
            // End current session
            const lastSession = value.sessions[value.sessions.length - 1];
            if (lastSession && !lastSession.endTime) {
                const updatedSessions = value.sessions.map((session) => session === lastSession
                    ? { ...session, endTime: Date.now(), duration: displaySeconds - (lastSession.duration || 0) }
                    : session);
                onChange({
                    totalSeconds: displaySeconds,
                    isRunning: false,
                    sessions: updatedSessions,
                });
                console.log('[Time Tracking Paused]', { totalSeconds: displaySeconds });
            }
        }
    };
    const handleReset = () => {
        if (readonly)
            return;
        if (window.confirm('Reset all tracked time for this item?')) {
            setDisplaySeconds(0);
            setIsRunning(false);
            onChange({
                totalSeconds: 0,
                isRunning: false,
                sessions: [],
            });
            console.log('[Time Tracking Reset]');
        }
    };
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsxs("div", { className: "flex-1 flex items-center gap-2", children: [_jsx(Clock, { className: "w-4 h-4 text-gray-400 flex-shrink-0" }), _jsx("span", { className: "text-sm font-mono font-medium text-white", children: formatTime(displaySeconds) })] }), !readonly && (_jsxs("div", { className: "flex items-center gap-1", children: [_jsx("button", { onClick: handlePlayPause, className: `p-1.5 rounded transition-colors ${isRunning
                            ? 'bg-red-500/20 text-red-400 hover:bg-red-500/30'
                            : 'bg-green-500/20 text-green-400 hover:bg-green-500/30'}`, title: isRunning ? 'Pause' : 'Start', children: isRunning ? (_jsx(Pause, { className: "w-4 h-4" })) : (_jsx(Play, { className: "w-4 h-4" })) }), displaySeconds > 0 && (_jsx("button", { onClick: handleReset, className: "p-1.5 rounded bg-gray-600/50 text-gray-400 hover:bg-gray-600 transition-colors", title: "Reset", children: _jsx(X, { className: "w-4 h-4" }) }))] }))] }));
};
